/** "80%" / "79.7%", or "—" when there was nothing to divide by (the API sends null). */
export function fmtPct(value) {
  if (value === null || value === undefined) return '—';
  const n = Number(value);
  return `${Number.isInteger(n) ? n : n.toFixed(1)}%`;
}

/** Bar width for a percentage, clamped to 0–100. */
export function barWidth(value) {
  if (value === null || value === undefined) return 0;
  return Math.max(0, Math.min(100, Number(value)));
}

/** "Target 60 · 9 short" / "Target 15 · 2 ahead" / "Target 10 · on target". */
export function targetText(line) {
  if (!line) return null;
  const { target, variance } = line;
  if (variance < 0) return `Target ${target} · ${-variance} short`;
  if (variance > 0) return `Target ${target} · ${variance} ahead`;
  return `Target ${target} · on target`;
}

export function signed(n) {
  if (n > 0) return `+${n}`;
  if (n < 0) return `−${-n}`;
  return '0';
}

export function errorMessage(error, fallback) {
  const message = error?.response?.data?.message || error?.message;
  if (typeof message === 'string' && message.trim()) return message;
  if (error?.response?.status === 403) return 'You do not have access to this report.';
  return fallback;
}
